import { ViewCell } from '@theme/components/grid/ng2-smart-table/components/cell/cell-view-mode/view-cell';
import { OnInit, Input, Component } from '@angular/core';
import { StatusColumn } from '../../ng2-smart-table/lib/data-set/status-column';

@Component({
    selector: 'status-view-cell',
    template: `
    <div class="status-view-cell {{ status }}">
      {{ this.renderValue }}
    </div>
  `,
    styleUrls: ['./status-view-cell.component.scss'],
    standalone: false
})
export class StatusViewCellComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: string | number;
  @Input() status: string | number;
  @Input() rowData: any;
  @Input() settings: StatusColumn;

  ngOnInit() {
    if (this.settings.statusType && (this.value != undefined && this.value != null)) {
      this.renderValue = this.settings.statusType[this.value].renderValue;
      this.status = this.settings.statusType[this.value].status;
    }

  }
}
